// @flow
import client from '../../client'

// Types
import type { TTravelAgent } from './register'

// API Endpoints
export const TRAVEL_AGENT_ENDPOINT = '/travel_agent/'

/**
 * Returns travel agent information
 * @return {Promise|Error} A resolved Promise with travel agent profile or Rejected with an Error
 */
export const getProfile = (): Promise<TTravelAgent> =>
  client.get(TRAVEL_AGENT_ENDPOINT)

export default getProfile
